import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import JourneyType from "@/models/Timesheets/JourneyType";
import JourneyCalculationType from "@/models/Timesheets/JourneyCalculationType";

export default class UpdateTimesheetDetailsRequest extends BaseUpdateRequest {
    payRate: number;
    chargeRate: number;
    break: number;
    isPaidBreak: boolean;
    startAt: Date;
    endAt: Date;
    isJourneyTrackingEnabled: boolean;
    isSplitPayAndCharge = true;
    journeyType: JourneyType;
    journeyCalculationTypeForPay: JourneyCalculationType;
    journeyCalculationTypeForCharge: JourneyCalculationType;
    journeyTemplateForPayId: string;
    journeyTemplateForChargeId: string;
    distanceOneWayForPay: number;
    distanceOneWayForCharge: number;
    travelTimeOneWayForPay: number;
    travelTimeOneWayForCharge: number;
    isDriverExpensePayable: boolean;
    isDriverExpenseChargeable: boolean;
    isTravelTimePayable: boolean;
    isTravelTimeChargeable: boolean;
}

